import { createRouter, createWebHistory } from "vue-router";
import userInfo  from "../utils/userInfo";
import Signin from "../views/Signin.vue";

const customerInfo = new userInfo();
function checkIsLogged() {
  return customerInfo.getIsLogged()
}

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/requests",
  },
  {
    path: "/requests",
    name: "Requests",
    component: () => import('../views/Requests.vue'),
    beforeEnter: [checkIsLogged],
    props: true,
    meta: {
      reload: null,
    },
  },
  {
    path: "/message",
    name: "MessagePg",
    component: () => import('../views/components/MessagePg.vue'),
    beforeEnter: [checkIsLogged],
    props: true
  },
  {
    path: "/stats",
    name: "Stats",
    component: () => import('../views/Stats.vue'),
    beforeEnter: [checkIsLogged],
    props: true
  },
  {
    path: "/sponsorships",
    name: "Sponsorships",
    component: () => import('../views/Sponsorships.vue'),
    beforeEnter: [checkIsLogged],
    props: true
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/Profile.vue"),
    beforeEnter: [checkIsLogged]
  },
  {
    path: "/new-ad-step-one",
    name: "NewAdOne",
    component: () => import("../views/NewAdOne.vue"),
    beforeEnter: [checkIsLogged],
    props: true
  },
  {
    path: "/new-ad-step-two",
    name: "NewAdTwo",
    component: () => import("../views/NewAdTwo.vue"),
    beforeEnter: [checkIsLogged],
    props: true
  },
  {
    path: "/new-ad-step-three",
    name: "NewAdThree",
    component: () => import("../views/NewAdThree.vue"),
    beforeEnter: [checkIsLogged],
    props: true
  },
  {
    path: "/ads",
    name: "Ads",
    component: () => import("../views/Ads.vue"),
    beforeEnter: [checkIsLogged],
    props: true
  },
  {
    path: "/ad",
    name: "Ad",
    component: () => import('../views/Ad.vue'),
    props: true
  },
  {
    path: "/logistics",
    name: "logistics",
    component: () => import('../views/Logistics.vue'),
    props: true
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  
})

export default router;
